import { useEffect, useRef, useState } from "react";
import { useRobotPeerConnection } from "features/robot-teleop/contexts/RobotConnectionContext";
import EDynamicLinesChart from "shared/components/ui/chart/EDynamicLinesChart";

const JitterGraph = ({ MaxDuration, ZoomWindowSize }) => {
  const { addStatsUpdatedEventListener, removeStatsUpdatedEventListener } =
    useRobotPeerConnection();

  const maxDuration = MaxDuration || 1 * 60 * 60; //3600 seconds
  const windowSize = ZoomWindowSize || 1 * 60 * 10; // 10 minutes
  const zoomEnd = 100;
  const zoomStart = Math.max(0, 100 - (windowSize / maxDuration) * 100);

  const [data, setData] = useState([
    [Date.now() - maxDuration * 1000, 0],
    [Date.now(), 0],
  ]);

  const statsUpdatedHandler = (obj) => {
    const videoJitter = obj.videoJitter * 1000;
    if (obj.videoJitter == -1) return;
    const now = Date.now();
    setData((prevData) => {
      const newData = [...prevData, [now, videoJitter]];
      if (newData.length > maxDuration) {
        newData.shift();
      }
      return newData;
    });
  };

  const series = [
    {
      name: "Jitter",
      type: "line",
      symbol: "none",
      // areaStyle: {},
      data: data,
      smooth: false,
      lineStyle: { color: "#ff6b6b", width: 1 },
      itemStyle: { color: "#ff6b6b" },
    },
  ];

  useEffect(() => {
    console.log("setting data");
    addStatsUpdatedEventListener(statsUpdatedHandler);
    return () => {
      console.log("useEffect cleanup");
      removeStatsUpdatedEventListener(statsUpdatedHandler);
    };
  }, []);

  return (
    <div
      className="jitter-graph-container"
      style={{ height: "100%", width: "100%" }}
    >
      <EDynamicLinesChart
        enableZoom={true}
        enableBrush={true}
        enableToolbox={true}
        initialZoomStart={zoomStart}
        initialZoomEnd={zoomEnd}
        height="100%"
        width="100%"
        backgroundColor="#fff"
        series={series}
        // title={"Jitter"}
        legend={{
          show: true,
          top: 10,
          data: ["Jitter"],
        }}
        // yAxis={{
        //   name: "values",
        //   nameLocation: "middle",
        //   nameGap: 40,
        // }}
        dataZoomOptions={{
          inside: {
            zoomOnMouseWheel: true,
            moveOnMouseMove: true,
          },
          slider: {
            show: true,
            backgroundColor: "#f5f5f5",
          },
        }}
        tooltipOptions={{ show: false }}
      />
    </div>
  );
};

export default JitterGraph;
